import axios from './axios'
import config from '../config'

export default {
    listNews(params) {
        return axios({
            url: config.backendUrl + '/common/news-section-edit/list',
            method: 'GET',
            params
        })
    },
    getNewsDetails(params) {
        return axios({
            url: config.backendUrl + '/common/news-section-edit/details',
            method: 'GET',
            params
        })
    },
    updateNews(params, data) {
        return axios({
            url: config.backendUrl + '/common/news-section-edit/update',
            method: 'POST',
            params,
            data
        })
    },
    addSectionNewsNotification(params) {
        return axios({
            url: config.backendUrl + '/common/news-section-edit/notification',
            method: 'POST',
            params
        })
    },
    checkSectionNewsNotifications(sectionId, docIds) {
        return axios({
            url: config.backendUrl + '/common/news-section-edit/check-notification',
            method: 'POST',
            params: {sectionId},
            data: docIds
        })
    }
}
